// extracted by mini-css-extract-plugin
module.exports = {"card":"StatsItemSkeleton_card__1Bl-W"};